import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import { useToggle } from 'react-use';

import styles from './chart.module.css';
import DropdownMenu from "../../dropdown/DropdownMenu";
import LineChart from './LineChart';
import ColumnChart from './ColumnChart';
import Table from './Table';
import ClickOutside from '../../ClickOutside';

export const LIST_VIEW = 'list-view';
export const LINE_CHART_VIEW = 'line-chart-view';
export const COLUMN_CHART_VIEW = 'column-chart-view';


function CardChart(props) {
    const { title, description, data, type, updated_date_text, toggleWidth, onToggleWidth, onChangeAction, onUpdateNote, onUpdateTitle } = props;

    const [on, toggle] = useToggle(false);
    const [titleRaw, setTitleRaw] = useState('');
    const [note, setNote] = useState('');
    const [downloadCSV, setDownloadCSV] = useState(false);

    useEffect(() => {
        setNote(description);
    }, [description]);

    useEffect(() => {
        setTitleRaw(title);
    }, [title]);

    return <div className={styles.chartWrapper}>
        <div className={styles.titleWrapper}>
            <h3 className={styles.title}>
                <input type="text"
                    value={titleRaw}
                    className={styles.input}
                    onBlur={() => onUpdateTitle(titleRaw)}
                    onChange={(e) => setTitleRaw(e.target.value)}
                />
                <div className="explain-text">
                    {updated_date_text}
                </div>
            </h3>
            <div className={styles.titleRightWrapper}>
                <div style={{ position: 'relative' }}>
                    <ClickOutside onClickOutside={() => toggle(false)}>
                        <button className={classNames(styles.buttonChart)}
                            style={{
                                paddingLeft: 15,
                                display: 'flex',
                                alignItems: 'center',
                            }} onClick={toggle}>
                            <img src={description ? '/img/ic_comment_bold.svg' : '/img/ic_comment_light.svg'} alt="" />
                        </button>
                        {on && <div className={styles.inputWrapper}>
                            <textarea value={note || ''}
                                onBlur={() => onUpdateNote(note)}
                                className={styles.inputWrapperTextarea}
                                onChange={(e) => setNote(e.target.value)}
                                rows="4"
                                placeholder={'メモ'}
                            />
                        </div>}
                    </ClickOutside>
                </div>
                <button className={classNames(styles.buttonChart)}
                    style={{
                        paddingLeft: 10,
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    onClick={onToggleWidth}>
                    <img src={toggleWidth ? '/img/graph/grid_full.svg' : '/img/graph/grid_left.svg'} alt="" />
                </button>
                <DropdownMenu position={'right'}
                    list={[
                        type === LIST_VIEW ?
                            { name: '項目設定', value: 'swapField' } :
                            { name: 'グラフ設定', value: 'setting' }
                        ,
                        { name: '絞り込み', value: 'collapse' },
                        { name: 'CSVダウンロード', value: 'csv' },
                        { name: '削除', value: 'remove' }
                    ]}
                    getOptionLabel={(option) => option.name}
                    onChange={(item) => {
                        if (item.value === 'csv') {
                            setDownloadCSV(true);
                            setTimeout(() => {
                                setDownloadCSV(false);
                            }, 1000);
                            return;
                        }
                        onChangeAction(item, type);
                    }}>
                    <img style={{ paddingLeft: 7, paddingRight: 7 }} src="/img/more_vert_24px.png" className={'more-button-action'} alt="more" />
                </DropdownMenu>
            </div>
        </div>
        <div style={{ padding: 15, height: 350 }}>
            {type === LIST_VIEW && <Table
                headers={data.headers}
                data={data.values}
                downloadCSV={downloadCSV}
                title={titleRaw}
                description={description}
            />}
            {type === LINE_CHART_VIEW && <LineChart
                headers={data.headers}
                data={data.values}
                options={data.options}
                downloadCSV={downloadCSV}
                title={titleRaw}
                description={description}
            />}
            {type === COLUMN_CHART_VIEW && <ColumnChart
                headers={data.headers}
                data={data.values}
                options={data.options}
                downloadCSV={downloadCSV}
                title={titleRaw}
                description={description}
            />}
        </div>
        {description && <p className={styles.description}>
            {description}
        </p>}
    </div>
}

CardChart.propTypes = {
    title: PropTypes.string,
    toggleWidth: PropTypes.bool,
    description: PropTypes.string,
    data: PropTypes.object.isRequired,
    type: PropTypes.string,
    updated_date_text: PropTypes.string,
    onChangeAction: PropTypes.func,
    onUpdateNote: PropTypes.func,
};

CardChart.defaultProps = {
    title: '',
    description: '',
    type: LINE_CHART_VIEW,
    updated_date_text: '',
    data: {
        headers: [],
        values: [],
        options: {},
    },
    onToggleWidth: () => { },
    onUpdateNote: () => { },
    onUpdateTitle: () => { },
};

export default CardChart;